import { useEffect } from "react";

let dataString = "";
let timeoutId;

const BarCodeComponent = (props) => {
  const { onScan, setProductSearchInput } = props;
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const posScanConfigs = tillData.posScanConfigs.filter((item) => item.formula !== null && item.scanTrxType === "PR" && item?.qrCode === "Y");

  const handleKeyPress = (e) => {
    const { charCode, key } = e;
    console.log("dataString before:", dataString);

    // Reset timeout if it exists
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    // Set a timeout to clear dataString after inactivity
    timeoutId = setTimeout(() => {
      dataString = "";
      timeoutId = undefined;
    }, 200); // Reduced to 100ms for faster reset between scans

    // Build the barcode string
    if (posScanConfigs?.length > 0) {
      if (
        (charCode >= 48 && charCode <= 57) || // 0-9
        (charCode >= 65 && charCode <= 90) || // A-Z
        (charCode >= 97 && charCode <= 122) || // a-z
        charCode === 45 || // -
        charCode === 32 || // space
        charCode === 123 || // {
        charCode === 125 || // }
        charCode === 34 || // "
        charCode === 58 || // :
        charCode === 44 // ,
      ) {
        dataString += key;
      }
    } else {
      if (
        (charCode >= 48 && charCode <= 57) || // 0-9
        (charCode >= 65 && charCode <= 90) || // A-Z
        (charCode >= 97 && charCode <= 122) || // a-z
        charCode === 45 || // -
        charCode === 32 // space
      ) {
        dataString += key;
      }
    }

    // Process barcode when Enter (charCode 13) is pressed
    const productName = localStorage.getItem("productName");
    const productSegment = localStorage.getItem("productSegment");
    if (charCode === 13 && dataString !== "" && productName === null && !productSegment) {
      setProductSearchInput(""); // Clear search input
      let products = [];
      const posConfig = tillData?.posScanConfigs?.filter((item) => item.formula !== null && item.scanTrxType === "PR");
      const posConfigItem = posConfig?.filter((item) => dataString.startsWith(item.startsWith));

      if (posConfigItem?.length > 0) {
        const config = posConfigItem[0];
        if (config.delimiter) {
          products = dataString.split(config.delimiter).filter(Boolean); // Split and remove empty entries
        }
      }
      console.log("products", dataString);

      // Set a delay before calling onScan
      const delay = 200; // Delay in milliseconds (adjust as needed)
      clearTimeout(timeoutId); // Clear previous timeout if exists

      timeoutId = setTimeout(() => {
        // console.log("Scan dataString", dataString);
        // onScan(dataString.trim(), false);
        const cleanedData = dataString.replace(/\s+/g, ""); // Remove all spaces & newlines

        // Ensure that each product is exactly 13 characters long
        if (posScanConfigs.length > 0 && cleanedData.startsWith("{") && cleanedData.endsWith("}")) {
          // QR code mode - parse JSON
          try {
            onScan(cleanedData, false);
          } catch (e) {
            console.error("JSON parse error:", e);
            processProducts([cleanedData]);
          }
        } else {
          products = cleanedData.match(/.{1,13}/g) || [];
          processProducts(products.length > 0 ? products : [dataString]);
        }

        // Reset state
        dataString = "";
        timeoutId = undefined;
      }, delay);
    } else if (productName !== null && charCode === 13 && !productSegment) {
      let prodCode = localStorage.getItem("productName");
      setProductSearchInput("");
      dataString = "";
      localStorage.removeItem("productName", "");
      onScan(prodCode, false);
    }
  };

  // Sequential processing of products
  const processProducts = async (products) => {
    try {
      for (const product of products) {
        await onScan(product, false);
      }
      console.log("All products processed successfully.");
    } catch (error) {
      console.error("Error processing products:", error);
    }
  };

  const handleKeyDown = (e) => {
    const { key } = e;
    console.log("dataString before:", dataString);

    // Reset timeout if it exists
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    // Set a timeout to clear dataString after inactivity
    timeoutId = setTimeout(() => {
      dataString = "";
      timeoutId = undefined;
    }, 200); // Short timeout to differentiate scan vs typing

    // Handle Backspace
    if (key === "Backspace") {
      dataString = dataString.slice(0, -1);
    }

    // Append character to dataString if it's alphanumeric or allowed symbols
    if (key.length === 1 && ((key >= "0" && key <= "9") || (key >= "A" && key <= "Z") || (key >= "a" && key <= "z") || key === "-" || key === " ")) {
      dataString += key;
    }

    // Process barcode when Enter is pressed
    if (key === "Enter" && dataString !== "") {
      const productName = localStorage.getItem("productName");
      const productSegment = localStorage.getItem("productSegment");

      console.log("Scan Submit:", productName, productSegment, dataString.trim());

      setProductSearchInput("");
      if (productName !== null && !productSegment) {
        localStorage.removeItem("productName");
        onScan(productName, false);
      } else {
        onScan(dataString.trim(), false);
      }

      // Clear dataString after scan
      dataString = "";
    }
  };

  useEffect(() => {
    if (posConfig?.product_search_display_mode === "dropdown") {
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        dataString = "";
        window.removeEventListener("keydown", handleKeyDown);
      };
    } else {
      window.addEventListener("keypress", handleKeyPress);
      return () => {
        dataString = ""; // Reset on unmount
        clearTimeout(timeoutId); // Clear any pending timeout
        window.removeEventListener("keypress", handleKeyPress);
      };
    }
  }, []); // Empty dependency array is fine here since tillData is static

  return null;
};

export default BarCodeComponent;
